<p-sidebar [(visible)]="visible" [position]="drawerPosition" [transitionOptions]="'300ms cubic-bezier(0.25, 0.8, 0.25, 1)'" (onHide)="closeSidebar()" styleClass="p-sidebar-md" appendTo="body"
  [baseZIndex]="10000">
  <div class="notif-redesign">
    <div class="drawer-head cream">
      <span class="drawer-title">{{'account.alerts' | translate}}</span>
      <div class="tools">
        <button type="button" class="drawer-tool reloadAlerts" (click)="getUserAlerts()"
          [attr.aria-label]="'account.alerts' | translate">
          <i class="pi pi-refresh" aria-hidden="true"></i>
        </button>
        @if (alerts && alerts.length > 0) {
        <button type="button" class="drawer-tool clearAlerts" (click)="clearAlers()"
          [attr.aria-label]="'account.alerts' | translate">
          <i class="pi pi-trash" aria-hidden="true"></i>
        </button>
        }
        <button type="button" class="drawer-close" (click)="closeSidebar()"
          [attr.aria-label]="'account.alerts' | translate">
          <i class="pi pi-times" aria-hidden="true"></i>
        </button>
      </div>
    </div>

    <div class="drawer-body">
      @if (alerts && alerts.length > 0) {
      <div class="notif-list">
        @for (alert of alerts; track $index) {
        <div [class]="alert.IsNew ? 'notif newAlert' : 'notif'">
          <div class="main" (click)="goToContext(alert)">
            <div class="who">{{alert.Subject}}</div>
            <div class="sub" [innerHTML]="alert.Text"></div>
          </div>
          <div class="notif-actions">
            <button type="button" class="x removeAlertIcon" (click)="removeAlert(alert)"
              [attr.aria-label]="'account.alerts' | translate">
              <i class="pi pi-times" aria-hidden="true"></i>
            </button>
            <button type="button" class="chat" (click)="goToContext(alert)"
              [attr.aria-label]="'account.alerts' | translate">
              @if (alert.Type === 1) {
              <i class="pi pi-comment dialogIcon" aria-hidden="true"></i>
              } @else if (alert.Type === 2) {
              <i class="pi pi-calendar calendarIcon" aria-hidden="true"></i>
              } @else if (alert.Type === 3) {
              <i class="pi pi-server calendarIcon" aria-hidden="true"></i>
              } @else {
              <i class="pi pi-comment" aria-hidden="true"></i>
              }
            </button>
          </div>
        </div>
        }
      </div>
      } @else {
      <div class="notif-empty">
        <i class="pi pi-bell" aria-hidden="true"></i>
        <div class="notif-empty-text">{{'account.noAlerts' | translate}}</div>
      </div>
      }
    </div>
  </div>
</p-sidebar>

<p-toast [showTransformOptions]="'translateY(100%)'" [showTransitionOptions]="'500ms'" [hideTransitionOptions]="'500ms'"
  [showTransformOptions]="'translateX(100%)'" key="newAlert">
  <ng-template let-message pTemplate="alertMessage">
    @if (alertMessage) {
    <div class="p-flex p-flex-column" style="flex: 1">
      <div class="p-text-left alertMessageBody">
        <h6>{{alertMessage.Subject}}</h6>
        <div [innerHTML]="alertMessage.Text"></div>
      </div>
    </div>
    }
  </ng-template>
</p-toast>
